<template>
  <div class="recommendFour">
    <recommend-title :titleObj="titleObj"></recommend-title>
    <div class="swiper-inner">
      <swiper :options="swiperOption">
        <swiper-slide v-for="(item,index) in list" :key="index">
          <list-panel :obj="item" :star="false"></list-panel>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>
<script>
import RecommendTitle from './recommendTitle'
import ListPanel from './listPanel'
export default {
  name: '',
  components: {
    'recommend-title': RecommendTitle,
    'list-panel': ListPanel
  },
  data () {
    return {
      swiperOption: {
        effect: 'slide', // coverflow
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
          rotate: 40,
          stretch: 0,
          depth: 100,
          modifier: 1
        },
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      titleObj: {
        color: '#BA9B69',
        text: '猜你喜欢',
        link: '/home/classification'
      },
      list: [{
        imgUrl: require('@/assets/images/2.png'),
        name: 'w我们从此是路人',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22',
        score: 5
      }, {
        imgUrl: require('@/assets/images/2.png'),
        name: '哈哈哈',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22',
        score: 2.5
      }, {
        imgUrl: require('@/assets/images/2.png'),
        name: '哈哈哈',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22',
        score: 5
      }, {
        imgUrl: require('@/assets/images/2.png'),
        name: '哈哈哈',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22',
        score: 0
      }, {
        imgUrl: require('@/assets/images/2.png'),
        name: '哈哈哈',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22'
      }, {
        imgUrl: require('@/assets/images/2.png'),
        name: '哈哈哈',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22',
        score: 5
      }, {
        imgUrl: require('@/assets/images/2.png'),
        name: '哈哈哈',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22',
        score: 0
      }, {
        imgUrl: require('@/assets/images/2.png'),
        name: '哈哈哈',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22'
      }, {
        imgUrl: require('@/assets/images/2.png'),
        name: '哈哈哈',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22',
        score: 5
      }, {
        imgUrl: require('@/assets/images/2.png'),
        name: '哈哈哈',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22',
        score: 0
      }, {
        imgUrl: require('@/assets/images/2.png'),
        name: '哈哈哈',
        author: '老王',
        oldMoney: '100.00',
        nowMoney: '50.22'
      }]
    }
  }
}
</script>
<style lang="less" scoped>
  .recommendFour{
    padding: 0 10px;
  }
  .swiper-inner {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 220px;
  }
  .recommendOne{
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/recommendFour.vue


// WEBPACK FOOTER //
// src/components/Home/recommendFour.vue